export interface SceneTheme {
  id: string;
  label: string;
  description?: string;
  background: number;
  fog: number;
  robotBody: number;
  robotFrame: number;
  groundLight: string;
  groundDark: string;
  axisX: number;
  axisY: number;
}

export const THEMES: SceneTheme[] = [
  {
    id: 'stealth',
    label: 'Stealth Black/Teal',
    description: 'Monochrome frame with teal training floor.',
    background: 0x04080f,
    fog: 0x04080f,
    robotBody: 0x090b10,
    robotFrame: 0x0f1219,
    groundLight: '#3ce0c7',
    groundDark: '#063930',
    axisX: 0xfb5a5f,
    axisY: 0x2ecc71,
  },
  {
    id: 'mujoco',
    label: 'MuJoCo Orange/Black',
    description: 'Matches the desktop MuJoCo screenshot.',
    background: 0x0a111c,
    fog: 0x0a111c,
    robotBody: 0xff6f1c,
    robotFrame: 0x1b1f27,
    groundLight: '#cde6bf',
    groundDark: '#1d472a',
    axisX: 0xfb5a5f,
    axisY: 0x2ecc71,
  },
  {
    id: 'lab-white',
    label: 'Lab White/Blue',
    description: 'Clean lab feel: white shell, navy frame, cyan floor.',
    background: 0x0b1220,
    fog: 0x0b1220,
    robotBody: 0xf5f5f5,
    robotFrame: 0x142137,
    groundLight: '#d2f0ff',
    groundDark: '#0a4265',
    axisX: 0xff3366,
    axisY: 0x4cd964,
  },
];

export const DEFAULT_THEME = THEMES[0];

export function getThemeById(id: string): SceneTheme | undefined {
  return THEMES.find((theme) => theme.id === id);
}
